<div class="feedCard">
  <vc-feed-card-profile
    *ngIf="card.cardType !== 'recommended-profiles'"
    class="feedCard__profile"
    [profile]="card.actor"
    [cardType]="card.cardType"
    (seeMember)="trackSeeProfile($event)"
    (followMemberFeed)="followMember($event)"
  ></vc-feed-card-profile>
  <ng-container [ngSwitch]="card.cardType">
    <!-- TODO: switch case should come from an enum -->
    <vc-feed-card-new-ins
      *ngSwitchCase="'new-in'"
      [activities]="card.orderedProducts"
      [profile]="card.actor"
      [totalCardActivities]="card.totalCardActivities"
      (seeProduct)="trackSeeProduct($event)"
      (likeProduct)="trackLikeProduct($event)"
      (seeMoreProduct)="trackSeeMoreProduct($event)"
      [likedItems]="likedItems"
    ></vc-feed-card-new-ins>
    <vc-feed-card-price-drops
      *ngSwitchCase="'price-drop'"
      [activities]="card.orderedProducts"
      [profile]="card.actor"
      [totalCardActivities]="card.totalCardActivities"
      (seeProduct)="trackSeeProduct($event)"
      (likeProduct)="trackLikeProduct($event)"
      (seeMoreProduct)="trackSeeMoreProduct($event)"
      [likedItems]="likedItems"
    ></vc-feed-card-price-drops>
    <vc-feed-suggestions
      *ngSwitchCase="'recommended-profiles'"
      [profiles]="card.recommendedProfiles"
      [newFollow]="true"
      [cardType]="card.cardType"
      (onFollowProfile)="trackRecommended($event)"
      (onSeeProfile)="trackSeeProfile($event)"
      (onHideProfile)="trackHideRecommended($event)"
    ></vc-feed-suggestions>
  </ng-container>
</div>
<vc-feed-suggestions
  [profiles]="card.recommendedProfiles"
  [newFollow]="newFollow"
  (onFollowProfile)="trackRecommended($event)"
  (onSeeProfile)="trackSeeProfile($event)"
></vc-feed-suggestions>
